<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import TreeNode from './TreeNode.svelte';
  
  export let documentTreeData: any[] = [];
  
  const dispatch = createEventDispatcher<{
    documentClick: { documentId: string; documentTitle: string };
  }>();

  function handleDocumentClick(event: CustomEvent<{ documentId: string; documentTitle: string }>) {
    dispatch('documentClick', event.detail);
  }
</script>

<ul class="doc-tree">
  {#each documentTreeData as node, i}
    <TreeNode {node} path={i+''} on:documentClick={handleDocumentClick} />
  {/each}
</ul>

<style>
</style> 